<script> 
	import { 
		headerTitleHome, 
		linkAV, 
		linkAVConheca, 
		linkPesquisaVendas,
		linkPesquisaLocacao,
		textSite,
	} from '../store.js';
	
	import { link }         from "svelte-routing";
	import Vitrine          from '../components/Vitrine.svelte'
	import Busca            from '../components/Busca.svelte'
	import ListaImoveis     from '../components/ListaImoveis.svelte'
	import Boleto           from '../components/Boleto.svelte'
	import PopUp			from '../components/PopUp.svelte'
	
	let vitrines = [
		{
			image: 'vitrineAV.jpg', 
			imageMobile: 'vitrineAVM.jpg', 
			title: 'Aplicativo Dinmar',
			href: $linkAVConheca
		},
	];

	/* Imóveis */ 
	function search(e) {
		const url = '/imoveis/' + (e.tipo_negociacao == '2'?'vendas':'locacao') + '#' + Object.entries(e.detail).filter(p=>p[1].length>0).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}
	
	let filtrosDestaquesVendas  = {nt:2, tipo_negociacao:2, cidade:'Porto Alegre', pageSize:6, random: 1};
	let filtrosDestaquesLocacao = {nt:1, tipo_negociacao:1, cidade:'Porto Alegre', pageSize:6, random: 1};

	function activateSlickVendas() {
		activateSlick('.destaques-home--vendas');
	}
	function activateSlickLocacao() {
		activateSlick('.destaques-home--locacao');
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
						}
					}
				]            
			});
		}, 500);
	}    
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<h1 class="text-seo">{$headerTitleHome}</h1>

<Vitrine vitrines={vitrines} vitrineHeight="350px"/>

<section class="busca">
	<div class="container">
		<Busca on:filter={search} /> 
	</div>
</section>

<!-- Destaques Locação -->
<section style="display: none;" class="section destaques-home destaques-home--locacao mb-50">
	<div class="container">
		<div class="header">
			<h2 class="title">Imóveis para <b class="color-primary">Alugar</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaLocacao}" title="Ofertas para alugar - {$textSite}">
				<i class="fas fa-plus-circle color-primary"></i> <b>Veja mais imóveis</b>
			</a>                
		</div>
		<ListaImoveis filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
	</div>
</section>  

<section class="section section-aplicativo bg-destaque mt-10">
	<div class="container">
		<div class="itens row align-items-center justify-content-center">
			<div class="item col-12 col-sm-6 col-md-7 d-flex justify-content-md-end justify-content-center">
				<img class="img-fluid" src="assets/images/mockup.png" alt="Mockup {$textSite}" width="450">
			</div>
			<div class="item item--content col-12 col-sm-6 col-md-5">
				<h2 class="title color-primary">
					Aplicativo Dinmar <br> Administradora de Imóveis
				</h2>
				<p class="no-breakline--xs color-destaque mt-10 mb-10">Todos os serviços em um único lugar. <br> Utilize no tablet, celular ou computador. <br> Comunicação rápida, prática e segura.</p>
				<div class="buttons">
					<a href={$linkAVConheca} target="_blank" class="hover-transform btn btn-secondary" title="Saiba mais {$textSite}">Saiba mais</a>
					<a href={$linkAV} target="_blank" class="hover-transform btn btn-primary" title="Acesse o {$textSite}">Acesse agora</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Destaques Vendas -->
<section style="display: none;" class="section destaques-home destaques-home--vendas pb-40">
	<div class="container">
		<div class="header mt-10">
			<h2 class="title">Imóveis para <b class="color-primary">Vender</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaVendas}" title="Ir para Ofertas para comprar - {$textSite}">
				<i class="fas fa-plus-circle color-primary"></i> <b>Veja mais imóveis</b>
			</a>
		</div>
		<ListaImoveis filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
	</div>
</section> 

<section class="section section-sobre" style="margin-bottom:-20px">
	<div class="container">
		<div class="content">
			<h4>Dinmar Administradora de imóveis</h4>
			<p>Desde 1983 atuando no mercado imobiliário, garantimos a tranquilidade de décadas de experiência para administrar o seu condomínio, seu imóvel e garantir sempre uma excelente negociação na compra e aluguel de imóveis, em Porto Alegre - RS.</p>
		</div>
	</div>
</section>

<Boleto />
<PopUp channel="site" />